import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
import { graphql } from 'gatsby';
import { ComponentHeader } from 'components/thumbprint-components';
export const pageQuery = graphql`
    {
        # Get links to by path to display in the navbar.
        platformNav: allSitePage(filter: { path: { glob: "/components/text-input/*/" } }) {
            edges {
                node {
                    ...PlatformNavFragment
                }
            }
        }
    }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ComponentHeader data={props.data} mdxType="ComponentHeader" />
    <h2>{`Summary`}</h2>
    <p>{`The single line text input control `}<inlineCode parentName="p">{`TextInput`}</inlineCode>{` is build upon the built-in UIKit component `}<inlineCode parentName="p">{`UITextField`}</inlineCode>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/textinput_default.png",
        "alt": "Default TextInput"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let textInput = TextInput()
`}</code></pre>
    <h2>{`Properties`}</h2>
    <h4>{`placeholder`}</h4>
    <p>{`The placeholder text that’s shown when no text has been entered. Placeholder text is shown in gray.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/textinput_placeholder.png",
        "alt": "Placeholder TextInput"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.placeholder = "Type something..."
`}</code></pre>
    <h4>{`hasError`}</h4>
    <p>{`If true, the control will be red. Use this property if something’s wrong and the text input control needs a user’s attention.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/textinput_error.png",
        "alt": "Error TextInput"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.hasError = true
`}</code></pre>
    <h4>{`isEnabled`}</h4>
    <p>{`If false, the control will not react to user interaction and will have a light gray color.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/textinput_disabled.png",
        "alt": "Disabled TextInput"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.isEnabled = false
`}</code></pre>
    <h4>{`isHighlighted`}</h4>
    <p>{`If true, the control has a blue border.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/textinput_highlighted.png",
        "alt": "Highlighted TextInput"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.isHighlighted = true
`}</code></pre>
    <h4>{`leftView and rightView`}</h4>
    <p>{`These properties are inherited from `}<inlineCode parentName="p">{`UITextField`}</inlineCode>{` and typically make it possible to show image based buttons on both sides of the text. More info can be found in the `}<a parentName="p" {...{
        "href": "https://developer.apple.com/documentation/uikit/uitextfield"
      }}>{`official UITextField documentation`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/textinput_leftview.png",
        "alt": "Leftview TextInput"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let leftView = UIButton(type: .system)
leftView.setTitle("left", for: .normal)
textInput.leftView = leftView
textInput.leftViewMode = .always
`}</code></pre>
    <h4>{`clearButtonMode`}</h4>
    <p>{`This property is inherited from `}<inlineCode parentName="p">{`UITextField`}</inlineCode>{` and determines when the standard clear button appears. More info can be found in the `}<a parentName="p" {...{
        "href": "https://developer.apple.com/documentation/uikit/uitextfield"
      }}>{`official UITextField documentation`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.clearButtonMode = .whileEditing
`}</code></pre>
    <h4>{`hidesCaret`}</h4>
    <p>{`Suppresses the cursor display while the control is active.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.hidesCaret = true
`}</code></pre>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      